import { getJson } from '#/utils/http/getJson';
import { postJson } from '#/utils/http/postJson';

import type { ApiNotification } from './types/ApiNotification';

export async function apiFetchNotifications(): Promise<ApiNotification[]> {
  return getJson<{ notifications: ApiNotification[] }>(
    '/data/notifications',
  ).then(({ notifications }) => notifications);
}

export async function apiMarkNotificationsAsViewed(notificationIds: string[]) {
  return postJson<{
    notifications: ApiNotification[];
  }>('/data/notifications-viewed', {
    notificationIds,
  }).then(({ notifications }) => notifications);
}

export async function apiMarkNotificationsAsRead(
  notificationIds: string[],
): Promise<ApiNotification[]> {
  return postJson<{
    notifications: ApiNotification[];
  }>('/data/notifications-read', {
    notificationIds,
  }).then(({ notifications }) => notifications);
}

export async function apiMarkNotificationsAsDismissed(
  notificationIds: string[],
): Promise<ApiNotification[]> {
  return postJson<{
    notifications: ApiNotification[];
  }>('/data/notifications-dismissed', {
    notificationIds,
  }).then(({ notifications }) => notifications);
}
